import { render } from "./AtencionesPorHoraDia.vue?vue&type=template&id=8ed5c290&scoped=true"
import script from "./AtencionesPorHoraDia.vue?vue&type=script&lang=js"
export * from "./AtencionesPorHoraDia.vue?vue&type=script&lang=js"

import "./AtencionesPorHoraDia.vue?vue&type=style&index=0&id=8ed5c290&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed5c290"]])

export default __exports__